import { render } from "./PremiumHandoverManagement.vue?vue&type=template&id=4ebdf27a&scoped=true"
import script from "./PremiumHandoverManagement.vue?vue&type=script&lang=js"
export * from "./PremiumHandoverManagement.vue?vue&type=script&lang=js"

import "./PremiumHandoverManagement.vue?vue&type=style&index=0&id=4ebdf27a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebdf27a"]])

export default __exports__